import { Spacer, TextCaption } from '@carboncopyco/ui';
import classNames from 'classnames';

interface StatusIndicatorProps {
  label?: string;
  danger?: boolean;
}
export const StatusIndicator = ({ label, danger }: StatusIndicatorProps) => {
  return (
    <div className="flex items-center">
      <div
        className={classNames(
          'w-1.5 h-1.5 rounded-full',
          danger ? 'bg-ds-danger' : 'bg-ds-accent2'
        )}
      />
      <Spacer amount={0.75} />
      <TextCaption
        label={label}
        color={'text-ds-natural-300'}
      />
    </div>
  );
};
